import React, { Component } from 'react';
import AltinKur from './../components/altinkur';
import DovizKur from './../components/dovizkur';
import Bant from './../components/bant';
import http from "./../services/httpService";
import config from "./../config.json";

class AltinSayfa extends Component {
    state = {  
        avalues: [],
        dvalues: [],
    }

    componentDidMount(){
        this.setValues();
        this.interval = setInterval(() => this.setValues(), 2000);
        document.title = "Altınkaynak Şirketler Grubu - Canlı Altın Bilgileri"
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    async setValues(){

        if(JSON.parse(localStorage.getItem('avalues')) !== null){
            this.setState({avalues:JSON.parse(localStorage.getItem('avalues')),dvalues:JSON.parse(localStorage.getItem('dvalues'))})
        }

        var {data : avalues} =  await http.get(config.restEndpoint + 'Gold');
        localStorage.setItem('avalues', JSON.stringify(avalues));
        var {data : dvalues} =  await http.get(config.restEndpoint + 'Currency');
        localStorage.setItem('dvalues', JSON.stringify(dvalues));

        if(avalues !== null & dvalues !== null)
            this.setState({dvalues,avalues})
    }

    render() { 
        return <React.Fragment>
                <Bant dvalues={this.state.dvalues} avalues={this.state.avalues}/>
                <div className="row">
                    <div className="col-lg-6">
                        <div className="row">
                            <div className="col-lg-12">
                                <AltinKur main={false} group={2} prepend={['XAUUSD']} emptyRows={1} showdescription={true} header={'Altın'} values={(this.state.avalues || []).concat(this.state.dvalues || [])}/>
                            </div>
                            <div className="col-lg-12">
                                <AltinKur main={false} group={10} append={['GA']} showdescription={true} header={<React.Fragment>Gram Altın <span className="hdr-note">(24 Ayar)</span></React.Fragment>} values={this.state.avalues}/>
                            </div>
                            <div className="col-lg-12">
                                <DovizKur main={true} group={3} goldHead={true} showdescription={true} header={'KG Altın'} values={this.state.dvalues} />
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                    <div className="row">
                        <div className="col-lg-12">
                            <AltinKur main={false} group={8} showdescription={true} header={'Yeni Sarrafiye'} values={this.state.avalues}/>
                        </div>
                        <div className="col-lg-12">
                            <AltinKur main={false} group={9} emptyRows={3} showdescription={true} header={'Eski Sarrafiye'} values={this.state.avalues}/>
                        </div>
                        <div className="col-lg-12">
                            <AltinKur main={false} group={7} prepend={['XAGUSD']} labels={{XAGUSD: 'Ons'}} silverHead={true} showdescription={true} header={'Gümüş'} values={(this.state.avalues || []).concat(this.state.dvalues || [])}/>
                        </div>
                    </div>
                    </div>
                </div>
            </React.Fragment>;
    }
}
 
export default AltinSayfa;